import { Target } from "lucide-react";
import { fmtOdds } from "../lib/api";

// Projection-first leg display: big projected amount, the book line it beats kept small.
export const ProjectedPick = ({ projection, metric, side, line, odds, book, booksAgree, booksTotal, testId }) => {
  if (projection == null) {
    return (
      <div className="font-data text-xs" data-testid={testId}>
        <span className={side === "OVER" ? "text-[#10B981]" : "text-[#EF4444]"}>{side} {line}</span>{" "}
        <span className="text-slate-300">{metric}</span>
        {odds != null && <span className="text-slate-500 ml-1">{fmtOdds(odds)}</span>}
      </div>
    );
  }
  return (
    <div data-testid={testId} className="mt-0.5">
      <div className="flex flex-wrap items-baseline gap-x-1.5">
        <Target className="h-3.5 w-3.5 text-[#00E5FF] self-center" />
        <span className="font-data text-lg font-bold text-white leading-none">{projection}</span>
        <span className="text-sm text-slate-200 whitespace-nowrap">{metric}</span>
        <span className="font-data text-[9px] uppercase tracking-wide text-[#00E5FF]">projected</span>
      </div>
      <div className="font-data text-[10px] text-slate-500 mt-0.5">
        {book ? `${book} line` : "Book line"} {side === "OVER" ? "o" : "u"}{line}
        {odds != null && ` · ${fmtOdds(odds)}`}
        {booksTotal ? (
          <span className={booksAgree / booksTotal > 0.5 ? "text-[#10B981]" : "text-[#F59E0B]"}>
            {" "}· {booksAgree}/{booksTotal} books agree
          </span>
        ) : null}
      </div>
    </div>
  );
};
